import { type FC } from 'react';

import { type IconProps } from './types';

export const ArrowsPayments2V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M65 35V65H35" stroke="#FFDD00" strokeWidth="2" />
      <path d="M1 31V1H31" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};

